/** Kaynak (amazon.com) ana kategorileri. Canlı search, inventory ve product_staging kaynak kayıtlarından.
 * Ağacın tamamı ./tree.ts içindedir ve yalnız yasaklı kategori ekranında yüklenir.
 */
export type SourceCategoryNode = {
  name: string;
  children: SourceCategoryNode[];
};

export const SOURCE_CATEGORY_ROOTS: { label: string; value: string }[] = [
  { label: "Appliances", value: "Appliances" },
  { label: "Apps & Games", value: "Apps & Games" },
  { label: "Arts, Crafts & Sewing", value: "Arts, Crafts & Sewing" },
  { label: "Automotive", value: "Automotive" },
  { label: "Baby Products", value: "Baby Products" },
  { label: "Beauty & Personal Care", value: "Beauty & Personal Care" },
  { label: "Books", value: "Books" },
  { label: "Car & Vehicle Electronics", value: "Car & Vehicle Electronics" },
  { label: "CDs & Vinyl", value: "CDs & Vinyl" },
  { label: "Cell Phones & Accessories", value: "Cell Phones & Accessories" },
  { label: "Clothing, Shoes & Jewelry", value: "Clothing, Shoes & Jewelry" },
  { label: "Collectibles & Fine Art", value: "Collectibles & Fine Art" },
  { label: "Credit & Payment Cards", value: "Credit & Payment Cards" },
  { label: "Digital Music", value: "Digital Music" },
  { label: "Dining & Entertaining", value: "Dining & Entertaining" },
  { label: "Electronics", value: "Electronics" },
  { label: "Everything Else", value: "Everything Else" },
  { label: "Food Service Equipment & Supplies", value: "Food Service Equipment & Supplies" },
  { label: "Grills & Outdoor Cooking", value: "Grills & Outdoor Cooking" },
  { label: "Grocery & Gourmet Food", value: "Grocery & Gourmet Food" },
  { label: "Health & Household", value: "Health & Household" },
  { label: "Heavy Duty & Commercial Vehicle Equipment", value: "Heavy Duty & Commercial Vehicle Equipment" },
  { label: "Home & Kitchen", value: "Home & Kitchen" },
  { label: "Hunting & Fishing", value: "Hunting & Fishing" },
  { label: "Industrial & Scientific", value: "Industrial & Scientific" },
  { label: "Instrument Accessories", value: "Instrument Accessories" },
  { label: "Janitorial & Sanitation Supplies", value: "Janitorial & Sanitation Supplies" },
  { label: "Kindle eBooks", value: "Kindle eBooks" },
  { label: "Kindle Store", value: "Kindle Store" },
  { label: "Kitchen & Dining", value: "Kitchen & Dining" },
  { label: "Lab & Scientific Products", value: "Lab & Scientific Products" },
  { label: "Lighting Assemblies & Accessories", value: "Lighting Assemblies & Accessories" },
  { label: "Lights, Bulbs & Indicators", value: "Lights, Bulbs & Indicators" },
  { label: "Medical Supplies & Equipment", value: "Medical Supplies & Equipment" },
  { label: "Mobility & Daily Living Aids", value: "Mobility & Daily Living Aids" },
  { label: "Motorcycle & Powersports", value: "Motorcycle & Powersports" },
  { label: "Movies & TV", value: "Movies & TV" },
  { label: "Musical Instruments", value: "Musical Instruments" },
  { label: "Office Electronics", value: "Office Electronics" },
  { label: "Office Products", value: "Office Products" },
  { label: "Outdoor Power Tools", value: "Outdoor Power Tools" },
  { label: "Pantry Staples", value: "Pantry Staples" },
  { label: "Patio, Lawn & Garden", value: "Patio, Lawn & Garden" },
  { label: "Performance Parts & Accessories", value: "Performance Parts & Accessories" },
  { label: "Pet Supplies", value: "Pet Supplies" },
  { label: "Power & Hand Tools", value: "Power & Hand Tools" },
  { label: "Power Tool Parts & Accessories", value: "Power Tool Parts & Accessories" },
  { label: "Remote & App Controlled Vehicle Parts", value: "Remote & App Controlled Vehicle Parts" },
  { label: "Remote & App Controlled Vehicles & Parts", value: "Remote & App Controlled Vehicles & Parts" },
  { label: "Restaurant Appliances & Equipment", value: "Restaurant Appliances & Equipment" },
  { label: "Safety & Security", value: "Safety & Security" },
  { label: "Shoe, Jewelry & Watch Accessories", value: "Shoe, Jewelry & Watch Accessories" },
  { label: "Small Appliance Parts & Accessories", value: "Small Appliance Parts & Accessories" },
  { label: "Software", value: "Software" },
  { label: "Spine", value: "Spine" },
  { label: "Sports & Outdoor Recreation Accessories", value: "Sports & Outdoor Recreation Accessories" },
  { label: "Sports & Outdoors", value: "Sports & Outdoors" },
  { label: "Stores", value: "Stores" },
  { label: "Tools & Home Improvement", value: "Tools & Home Improvement" },
  { label: "Toys & Games", value: "Toys & Games" },
  { label: "Video Games", value: "Video Games" },
];
